import { request } from './request'
import type { RoadmapPost } from './types'

export type CreateIdeaArgs = {
  title: string
  description: string
  authorEmail: string | null
}

export const createIdea = async ({
  title,
  description,
  authorEmail,
}: CreateIdeaArgs): Promise<RoadmapPost> => {
  const data = await request<{ post: RoadmapPost }>({
    path: '/api/posts',
    method: 'POST',
    body: { title, description, authorEmail },
  })

  return data.post
}
